module.exports = __webpack_public_path__ + "static/media/girl-1.038dbd32.svg";